import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';
import type { DefaultTheme } from '@mui/styles';
import { styled } from '@mui/styles';

import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';

interface ToggleProps extends BoxProps {
  toggleOn: boolean;
  label: string;
  handleToggle: () => void;
  disabled?: boolean;
}

export const Toggle = ({
  toggleOn,
  label,
  handleToggle,
  ...props
}: ToggleProps) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap="0.625rem"
      onClick={handleToggle}
      sx={{
        ...(props.disabled && {
          pointerEvents: 'none',
          opacity: 0.5,
        }),
      }}
      {...props}
    >
      {toggleOn ? (
        <ToggleOnIcon fontSize="medium" />
      ) : (
        <ToggleOffIcon fontSize="medium" />
      )}
      <ToggleLabel toggleOn={toggleOn}>{label}</ToggleLabel>
    </Box>
  );
};

const ToggleOnIcon = styled(ToggleOnOutlinedIcon)(({ theme }) => {
  return {
    fill: theme.config.colors.cowbellBlue,
    height: '4rem',
    width: '4rem',
  };
});

const ToggleOffIcon = styled(ToggleOffOutlinedIcon)(({ theme }) => {
  return {
    fill: theme.config.colors.darkGreySoft,
    height: '4rem',
    width: '4rem',
  };
});

type ToggleLabelProps = { toggleOn: boolean };
const ToggleLabel = styled('div')<DefaultTheme, ToggleLabelProps>(
  ({ theme, toggleOn }) => {
    return {
      fontSize: '1.2rem',
      fontWeight: 600,
      cursor: 'pointer',
      color: toggleOn
        ? theme.config.colors.cowbellBlue
        : theme.config.colors.darkGreySoft,
    };
  }
);
